<template>
  <div class="hardtwo">
    <!-- <newtwo></newtwo> -->
    <paratwo></paratwo>
    <moretwo></moretwo>
    <iphandle></iphandle>
    <foot></foot> 
  </div>
</template>
<script>
// import Newtwo from './newtwo'
import Moretwo from './moretwo'
import Paratwo from './paratwo'
import Iphandle from './iphandle'
import Foot from './foot'

export default {
  name:'hardtwo',
  components:{Moretwo,Paratwo,Iphandle,Foot },
}
</script>
<style scoped>
  @media screen and (max-width:768px){
    .hardtwo{
      margin-top: 48px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/hardProduct/hardtwo.vue